import { SolarBill } from '/imports/api/solarBills';
import { DeclareMethod } from '/imports/methods';

export interface NorthshoreBillingParams { batch: number, startDate: string, endDate: string, issuedDate: string, dueDate: string, consolidateIds?: string[] }
export const generateNorthshoreBills = DeclareMethod<NorthshoreBillingParams, number>('generateNorthshoreBills');
export const createNorthshoreConsolidatedBill = DeclareMethod<{billIds: string[]}, SolarBill>('createNorthshoreConsolidatedBill');
interface NorthshoreSendBillsParams { billIds: string[], subject: string, html: string, ccEmails?: string, test?: boolean, accessCode?: string }
export const sendNorthshoreBills = DeclareMethod<NorthshoreSendBillsParams, number>('sendNorthshoreBills');
